import getRegionByCodes from './getRegionByCodes';

/**
 * Returns an object that contains just the lat & long, or just the search term if lat & long are empty.
 * Note: if you are supplying a regionCode, you will need to supply a countryCode as well
 */
export default function buildSearchParameters({ lat, lng, search, area, countyId, regionCode, countryCode }) {
  let params = {};

  if (regionCode && countryCode) {
    const region = getRegionByCodes(regionCode, countryCode);

    if (region.name === area) {
      params = { countyId, regionCode, countryCode };
    } else {
      params = { area, countyId, regionCode, countryCode };
    }
  } else if (lat && lng) {
    params = { lat, lng };
  } else {
    params = { search };
  }

  return params;
}
